module.exports = {
      id: "filter-usage",
      viewBox: "0 0 8 8",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#filter",
      toString: function () {
        return this.url;
      }
    }